import {
  getFileDownloadUrl,
  getFilePlayUrls,
  getFileTranscodeState,
  postCheckFileStatus,
  postThirdUrl, putThirdUrl
} from './service';

/**
 * 截取文件-取文件的前缀和后缀
 *  */
export const getFilePrefix = (file, index) => {
  if (Object.keys(file).length && file.name.includes('.')) {
    if (index === 0) {
      return file.name.substring(0, file.name.lastIndexOf('.'));
    } else {
      return file.name.substring(file.name.lastIndexOf('.'));
    }
  }
  return file.name;
};

export const serviceMap = new Map([
  [
    'hwkEngine',
    {
      fetchTranscodeState: getFileTranscodeState,
      fetchDownloadUrl: getFileDownloadUrl,
      fetchPlayUrls: getFilePlayUrls
    }
  ],
  [
    'o2o',
    {
      fetchTranscodeState: postCheckFileStatus,
      fetchDownloadUrl: putThirdUrl,
      fetchPlayUrls: postThirdUrl
    }
  ]
]);
export const fetchTranscodeState = (service, ...data) => {
  if (service === 'o2o') data.push(6); // o2o 原接口，需要添加taskType 6 来与 作业引擎文件区分
  return serviceMap.get(service).fetchTranscodeState(...data);
};

export const fetchDownloadUrl = (service, ...data) => {
  return serviceMap.get(service).fetchDownloadUrl(...data);
};

export const fetchPlayUrls = (service, ...data) => {
  return serviceMap
    .get(service)
    .fetchPlayUrls(...data)
    .then(res =>
      service === 'hwkEngine' ? { data: { datas: res.data } } : res
    ); // 数据结构处理，保证两个服务下保持返回的数据结构相同
};

/**
 * 判断图片文件是否存在
 * */
export const checkImgExists = imgurl => {
  return new Promise((resolve, reject) => {
    var ImgObj = new Image();
    ImgObj.src = imgurl;
    ImgObj.onload = res => {
      resolve(res);
    };
    ImgObj.onerror = err => {
      reject(err);
    };
  });
};

export const downloadFileByHref = url => (window.location.href = url);
